import MoreIcon from '../../../../../assets/icons/more.svg?react';
import { MenuListStyle } from '../FileCard/style';
import { Popover } from 'react-tiny-popover';
import { Select } from '../../../../../components/Select';
import { LuGripVertical, LuMinus } from 'react-icons/lu';
import { useMemo } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { GroupLabel } from './style';

const formatGroupLabel = data => {
  return <GroupLabel>{data.label}</GroupLabel>;
};

export function SheetSelect({
  name,
  onClear,
  onClickMore,
  isOpenPopover,
  onClosePopover,
  isDisabled,
  showMore,
  showSourceSelect,
  onChange,
  onChangeSource,
  options,
  selectedSource,
  sources,
  dragProps,
  showDrag = false,
  handleRemove,
  sheetId,
  hideLine,
  hideLineReverse
}) {
  const groupedSources = useMemo(() => {
    const result = [
      {
        label: '  ',
        options: [
          {
            name: 'Manual Entry'
          }
        ]
      },
      ...(sources?.map(source => ({
        ...source,
        label: source.name,
        options: source.sheets
      })) || [])
    ];

    return result;
  }, [sources]);

  const isNewSheetMapping = showSourceSelect;

  return (
    <div className="sheet-item">
      {!hideLine && (
        <div className="among-line">
          <div></div>
          <div></div>
        </div>
      )}

      {!hideLineReverse && !isNewSheetMapping && (
        <div className="among-line-reverse">
          <div></div>
          <div></div>
        </div>
      )}

      <div className="sheet-wrapper">
        <div className="control">
          {!isDisabled && !isNewSheetMapping && showDrag ? (
            <button className="icon" {...dragProps}>
              <LuGripVertical />
            </button>
          ) : (
            <div
              {...dragProps}
              style={{
                display: !isDisabled && isNewSheetMapping && 'none',
                width: !(!isDisabled && isNewSheetMapping) && 21.5
              }}
            />
          )}

          {!isDisabled && isNewSheetMapping && (
            <button className="icon" onClick={handleRemove}>
              <LuMinus />
            </button>
          )}

          <div className="select">
            <div
              className="select-item"
              data-tooltip-content={name}
              data-tooltip-id="ligth-tooltip"
            >
              <Select
                size="sm"
                value={{ name }}
                isDisabled={isDisabled}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                menuShouldScrollIntoView={false}
                maxMenuHeight={260}
                options={options || []}
                getOptionLabel={opt => opt.name}
                getOptionValue={opt => opt.name}
                onChange={onChange}
                isSearchable
                styles={{
                  control: baseStyles => ({
                    ...baseStyles,
                    minHeight: '24px',
                    height: '24px',
                    borderColor: '#CED4DA',
                    fontSize: '12px'
                  }),
                  valueContainer: baseStyles => ({
                    ...baseStyles,
                    minHeight: '24px',
                    height: '24px',
                    fontSize: '12px',
                    padding: 0
                  }),
                  valueContainer2: baseStyles => ({
                    ...baseStyles,
                    minHeight: '24px',
                    height: '24px',
                    fontSize: '12px',
                    padding: 0
                  }),
                  placeholder: baseStyles => ({
                    ...baseStyles,
                    fontSize: '12px'
                  }),
                  indicatorsContainer: baseStyles => ({
                    ...baseStyles,
                    minHeight: '24px',
                    maxHeight: '24px',
                    height: '24px',
                    padding: 0
                  })
                }}
              />
            </div>

            {showSourceSelect && (
              <>
                <div className="select-item">
                  <Select
                    size="sm"
                    value={selectedSource}
                    isDisabled={isDisabled}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    minMenuHeight={260}
                    maxMenuHeight={260}
                    options={groupedSources || []}
                    getOptionLabel={opt => opt.name}
                    getOptionValue={opt => opt.name}
                    onChange={onChangeSource}
                    placeholder="Select Source"
                    isSearchable
                    formatGroupLabel={formatGroupLabel}
                    styles={{
                      control: baseStyles => ({
                        ...baseStyles,
                        minHeight: '24px',
                        height: '24px',
                        borderColor: '#CED4DA',
                        fontSize: '12px'
                      }),
                      valueContainer: baseStyles => ({
                        ...baseStyles,
                        minHeight: '24px',
                        height: '24px',
                        fontSize: '12px',
                        padding: 0
                      }),
                      valueContainer2: baseStyles => ({
                        ...baseStyles,
                        minHeight: '24px',
                        height: '24px',
                        fontSize: '12px',
                        padding: 0
                      }),
                      placeholder: baseStyles => ({
                        ...baseStyles,
                        fontSize: '12px'
                      }),
                      indicatorsContainer: baseStyles => ({
                        ...baseStyles,
                        minHeight: '24px',
                        maxHeight: '24px',
                        height: '24px',
                        padding: 0
                      })
                    }}
                  />
                </div>
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.49967 2.66659C5.55416 2.66659 3.16634 5.0544 3.16634 7.99992C3.16634 10.9454 5.55416 13.3333 8.49967 13.3333C11.4452 13.3333 13.833 10.9454 13.833 7.99992C13.833 5.0544 11.4452 2.66659 8.49967 2.66659ZM1.83301 7.99992C1.83301 4.31802 4.81778 1.33325 8.49967 1.33325C12.1816 1.33325 15.1663 4.31802 15.1663 7.99992C15.1663 11.6818 12.1816 14.6666 8.49967 14.6666C4.81778 14.6666 1.83301 11.6818 1.83301 7.99992ZM7.83301 5.33325C7.83301 4.96506 8.13148 4.66659 8.49967 4.66659H8.50634C8.87453 4.66659 9.17301 4.96506 9.17301 5.33325C9.17301 5.70144 8.87453 5.99992 8.50634 5.99992H8.49967C8.13148 5.99992 7.83301 5.70144 7.83301 5.33325ZM7.16634 7.99992C7.16634 7.63173 7.46482 7.33325 7.83301 7.33325H8.49967C8.86786 7.33325 9.16634 7.63173 9.16634 7.99992V9.99992C9.53453 9.99992 9.83301 10.2984 9.83301 10.6666C9.83301 11.0348 9.53453 11.3333 9.16634 11.3333H8.49967C8.13148 11.3333 7.83301 11.0348 7.83301 10.6666V8.66659C7.46482 8.66659 7.16634 8.36811 7.16634 7.99992Z"
                    fill="#228BE6"
                  />
                </svg>
              </>
            )}
          </div>
        </div>

        {showMore && (
          <Popover
            isOpen={isOpenPopover}
            positions={['bottom', 'center']}
            onClickOutside={onClosePopover}
            content={
              <MenuListStyle style={{ marginRight: '60px' }}>
                <div onClick={onClear} className="menu-item delete">
                  <FiTrash2 />
                  Delete
                </div>
              </MenuListStyle>
            }
          >
            <button onClick={onClickMore}>
              <MoreIcon />
            </button>
          </Popover>
        )}
      </div>
    </div>
  );
}
